
import './App.css';
import './diwali.css';
import './offer.css';
import './MediaQueries.css';

import { MotionConfig } from "framer-motion";
import { useState, useEffect } from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation
} from 'react-router-dom';

import ScrollToTop from './Components/ScrollToTop';
import Home from './Pages/Home';
import Header from './Components/Header';
import Footer from './Components/Footer';
import About from './Pages/About';
import Features from './Pages/Features';
import Contact from './Pages/Contact';
import Industries from './Pages/Industries';
import Pricing from './Pages/Pricing';
import ErrorPage from './Pages/ErrorPage';
import TermsConditions from './Pages/TermsConditions';
import CancellationRefund from './Pages/CancellationRefund';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import CookiePolicy from './Pages/CookiePolicy';
import BookDemo from './Pages/BookDemo';
import CookieConsent from "./Components/CookieConsent";
import GoogleAnalytics from './Components/GoogleAnalytics';
import Blog from './Pages/Blog';
import BlogDetail from './Pages/BlogDetail';
import Sitemap from './Pages/Sitemap';
import DiwaliOffer from './Pages/DiwaliOffer';
import Offers from './Pages/Offers';


function AppLayout({ isMobile }) {
  const location = useLocation();

  const hideHeaderFooter = [
    '/diwali-offer',
    '/onbbits-offer'
  ].includes(location.pathname);


  return (
    <MotionConfig reducedMotion={isMobile ? "always" : "never"}>
      <ScrollToTop />
      <GoogleAnalytics />

      {!hideHeaderFooter && (
        <Header />
      )}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/features" element={<Features />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/industries" element={<Industries />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/book-a-demo" element={<BookDemo />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/cancellation-refund" element={<CancellationRefund />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />
        <Route path="/sitemap" element={<Sitemap />} />
        <Route path="/diwali-offer" element={<DiwaliOffer />} />
        <Route path="/onbbits-offer" element={<Offers />} />
        <Route path="/*" element={<ErrorPage />} />
     </Routes>

      {!hideHeaderFooter && (
        <Footer />
      )}

      <CookieConsent />
    </MotionConfig>
  );
}

function App() {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window !== 'undefined') {
      return (
        window.innerWidth <= 768 ||
        /iPhone|iPad|iPod/i.test(navigator.userAgent)
      );
    }
    return false;
  });

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(
        window.innerWidth <= 768 ||
        /iPhone|iPad|iPod/i.test(navigator.userAgent)
      );
    };

    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <BrowserRouter>
      <AppLayout isMobile={isMobile} />
    </BrowserRouter>
  );
}

export default App;
